import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://5969bf2f6a30452848c1eac2fd1ad444@o4508295849181184.ingest.de.sentry.io/4508295856652368",
  integrations: [],
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <App />,
);
